export const gradeCleanupRegex = /\b(?:Grade|School|tx.|ngss.)\b/gi;

export const compareGradeBands = (gradeA: string, gradeB: string): boolean => {
  const cleanGradeA = gradeA.replaceAll(gradeCleanupRegex, '');
  const cleanGradeB = gradeB.replaceAll(gradeCleanupRegex, '');

  return cleanGradeA === cleanGradeB;
};
